import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Main_Page() {
  

  return (
  
    <div className="fixed inset-0 flex flex-col overflow-hidden">
    {/* Navbar */}
    <div className='h-[3rem] w-full'>
      <Navbar  />
    </div>
  
    {/* Main content area */}
    <div className='flex flex-1 overflow-hidden'>
      <Sidebar />
      
      {/* Content area - removed overflow-y-auto to let components handle their own scrolling */}
      <div className='flex-1 overflow-hidden'>
        <ToastContainer />
        <Outlet />
      </div>
    </div>

  </div>
  );
}

export default Main_Page;
